import { render } from "./NKDataListItem.vue?vue&type=template&id=1fa56b6a"
import script from "./NKDataListItem.vue?vue&type=script&lang=js"
export * from "./NKDataListItem.vue?vue&type=script&lang=js"
script.render = render

export default script